import { render, staticRenderFns } from "./PatientProfileVueComponent.vue?vue&type=template&id=8bce752c&"
import script from "./PatientProfileVueComponent.vue?vue&type=script&lang=ts&"
export * from "./PatientProfileVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PatientProfileVueComponent.vue?vue&type=style&index=0&id=8bce752c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports